export default {
    name: "Trade vs delivery",
    data:
    {
        "id": "32ec57ae-7f8b-4624-ac8f-09ea34c59297",
        "title": "Trade vs delivery",
        "type": "Composite",
        "config": {
            "operator": "Subtract",
            "combine_on": "next_match",
            "left": {
                "id": "f6dc6a84-65af-41bc-abff-a53a5752f51f",
                "title": "NBP/TTF DA",
                "type": "Composite",
                "config": {
                    "operator": "Subtract",
                    "combine_on": "date",
                    "left": {
                        "id": "321ae9aa-21c0-436c-9dc3-6110b7768e91",
                        "title": "",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 21,
                            "product_id": 1,
                            "hour": "17",
                            "start_date": "2025-01-28",
                            "end_date": "2025-08-27"
                        }
                    },
                    "right": {
                        "id": "714cc514-8541-45c1-8cfb-65c7a5e9a2f9",
                        "title": "",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 14,
                            "product_id": 1,
                            "hour": "17",
                            "start_date": "2025-01-28",
                            "end_date": "2025-08-27"
                        }
                    }
                }
            },
            "right": {
                "id": "add8fb2b-6452-41d5-ba97-1b6539d842fe",
                "title": "NBP/TTF WD",
                "type": "Composite",
                "config": {
                    "operator": "Subtract",
                    "combine_on": "date",
                    "left": {
                        "id": "e131c080-76a7-4319-a696-ad44c91b1f9a",
                        "title": "",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 21,
                            "product_id": "49",
                            "hour": "12",
                            "start_date": "2025-01-28",
                            "end_date": "2025-08-27"
                        }
                    },
                    "right": {
                        "id": "fbe55f51-58ea-4fe6-aa63-a2db7887c320",
                        "title": "",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 14,
                            "product_id": 1,
                            "hour": "12",
                            "start_date": "2025-01-28",
                            "end_date": "2025-08-27"
                        }
                    }
                }
            }
        }
    }

}